import type { MethodBands } from "./figures";

// React-free, so the agentic review's agents (compiled on their own by its Node test) read the same marks as the screens.
/** Condition 2.9: the marks of the published method each kind of figure is read against (empty until the method has loaded). */
export const markSets = (b: MethodBands | undefined) => ({
  hhi: b ? [b.hhiModerate, b.hhiHigh] : [],
  delta: b ? [b.deltaHhiMinor, b.deltaHhiSignificant, b.deltaHhiPresumption] : [],
  guppi: b ? [b.guppiWatchPercent, b.guppiConcernPercent] : [],
  share: b ? [b.marketShareThresholdPercent] : [],
  /** The control test's stakes: above half confers sole control; from a quarter, de facto control may be possible. */
  control: b ? [b.controlMajorityPercent ?? 50, b.controlDeFactoFromPercent ?? 25] : [],
  /** The Deal Watch control screen: control acquired from half, possible from 30%. */
  dealControl: b ? [b.dealControlAcquiredFromPercent ?? 50, b.dealControlPossibleFromPercent ?? 30] : [],
  /** The shares of the simplified procedure and the dominance mark it never reaches. */
  simplified: b ? [b.simplifiedCombinedSharePercent, b.simplifiedCombinedShareWithSmallDeltaPercent, b.simplifiedVerticalSharePercent, b.marketShareThresholdPercent].filter((m): m is number => m != null) : [],
});
